/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_all_categories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All tools`)
};

const es_home_all_categories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las herramientas`)
};

const de_home_all_categories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Tools`)
};

const nl_home_all_categories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle tools`)
};

const fr_home_all_categories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les outils`)
};

const it_home_all_categories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti gli strumenti`)
};

const pt_br2_home_all_categories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as ferramentas`)
};

const pt_home_all_categories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as ferramentas`)
};

const ja_home_all_categories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのツール`)
};

const zh_home_all_categories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_all_categories = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_all_categories(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_all_categories", locale)
	if (locale === "en") return en_home_all_categories(inputs)
	if (locale === "es") return es_home_all_categories(inputs)
	if (locale === "de") return de_home_all_categories(inputs)
	if (locale === "nl") return nl_home_all_categories(inputs)
	if (locale === "fr") return fr_home_all_categories(inputs)
	if (locale === "it") return it_home_all_categories(inputs)
	if (locale === "pt-BR") return pt_br2_home_all_categories(inputs)
	if (locale === "pt") return pt_home_all_categories(inputs)
	if (locale === "ja") return ja_home_all_categories(inputs)
	return zh_home_all_categories(inputs)
};